import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { convertYouTubeIdToImg, convertImage } from 'appSrc/utils';
import AspectRatio from 'react-aspect-ratio';
import style from './styles/style.module.css';


class ArticleCoverImage extends PureComponent {
    constructor( props ) {
        super( props );
        this.state = {
            mounted: false,
            videoImage: convertYouTubeIdToImg( ( this.props.videoId || '' ), 'jpg' ),
        };
        this.regressionCount = 0;
    }
    componentDidMount() {
        this.setState( { mounted: true } );
    }
    determineImageSize = ( image, clientWidth ) => {
        if( !clientWidth ) { return image; }

        var size;

        if( clientWidth <= 720 ) {
            size = '/720x405';
        }
        if( clientWidth <= 592 ) {
            size = '/592x333';
        }
        if( clientWidth < 368 ) {
            size = '/368x207';
        }
        if( size ) {
            image = convertImage( image, size );
        }
        return image;
    }
    checkCoverImage = ( e ) => {
        if( ( this.regressionCount < 2 ) && e.target.naturalHeight <= 90 ) {
            ++this.regressionCount;
            switch ( this.regressionCount ) {
                case 1:
                    this.setState( {
                        videoImage: convertYouTubeIdToImg( this.props.videoId, 'med/jpg' ),
                    } );
                    break;
                case 2:
                    this.setState( {
                        videoImage: convertYouTubeIdToImg( this.props.videoId, 'small/jpg' ),
                    } );
                    break;
                default:
                    this.regressionCount = 3;
                    break;
            }
        }
    }
    render() {
        const { coverImage } = this.props;
        const { videoImage } = this.state;
        const usingVideo = !coverImage;

        var image = usingVideo ? videoImage : coverImage;

        if( this.state.mounted && !usingVideo ) {
            image = this.determineImageSize( coverImage, this._el && this._el.clientWidth );
        }
        return (
            <AspectRatio ratio="16/9" className={ style.articleCoverImage }
            style={ this.props.style } >
                <div className={ style.coverImage } ref={ ( el ) => { this._el = el; } }>
                    { this.state.mounted &&
                    <img className={ style.primaryImage }
                    onLoad={ usingVideo ? this.checkCoverImage : () => {} }
                    src={ image }
                    alt="cover image" />
                    }
                </div>
            </AspectRatio>
        );
    }
}
ArticleCoverImage.propTypes = {
    videoId: PropTypes.string,
    coverImage: PropTypes.string,
};

export default connect()( ArticleCoverImage );
